/**
 * @author xzc
 * 功能：凭证
 */

import { Service } from '@/tools'

export class ProofService<T extends TSettle.ProofPreposition> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TSettle.ProofPreposition}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  // 新增凭证
  // /api/settle/proof/v1/add
  add = <K extends T['ApiAdd']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAdd', data)

  // 分页查询凭证
  // /api/settle/proof/v1/page
  page = <K extends T['ApiProofPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPage', data)

  // 详情
  // /api/settle/proof/v1/detail
  detail = <K extends T['ApiDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDetail', data)

  // 记账
  // /v1/registerProof
  posting = <K extends T['ApiRegisterProof']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiRegisterProof', data)
}
